export enum STAGED_CART_ITEM_CART_OPERATION {
    filterOut = 'filter-out',
    none = 'none',
}
